<template>
  <div
    v-if="ready"
    class="modal is-active"
  >
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Updating {{ filing.year }} filing requirements
        </p>
        <button
          id="moda-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <checkbox
              v-model="requirements"
              :options="options"
            />
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          :class="{ 'is-loading': isSaving }"
          class="button is-cta is-small"
          @click.prevent="update"
        >
          Save
        </button>
      </footer>
    </div>
  </div>
</template>
<script>

import Vue from 'vue';
import { Checkbox } from '@phila/phila-ui';

export default {
  components: {
    Checkbox,
  },
  props: {
    filing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ready: false,
      isSaving: false,
      options: {
        'cityForm': 'City',
        'stateForm': 'State',
        'mayorForm': 'Mayor',
      },
      content: '',
      requirements: [],
    };
  },
  created () {
    this.preSelectOptions();
    this.ready = true;
  },
  methods: {
    preSelectOptions () {
      let i = 0;
      Object.keys(this.options).forEach(form => {
        if (this.filing[form] === 'Y') {
          Vue.set(this.requirements, i, form);
          i++;
        }
      });
    },
    closeModal() {
      if (!this.submitting) {
        this.$emit('close');
      }
    },
    async update () {
      this.isSaving = true;
      let updates = {};
      Object.keys(this.options).forEach(req => {
        if (this.requirements.includes(req)) {
          updates[req] = 'Y';
        } else {
          updates[req] = 'N';
        }
      });

      const save = await this.$store.dispatch('filing/saveFiling', {
        ...this.filing,
        ...updates,
      });

      if (save) {
        this.isSaving = false;
        this.$store.dispatch('filings/fetchUserFilings', this.$store.state.user.tempId);
        this.closeModal();
        this.$success("Filing saved");
        return;
      }

      this.$warning("Something went wrong while saving this filing");
      this.isSaving = false;

    },
  },
};
</script>
<style lang="scss" scoped>
  .close-button {
    font-size: 25px;
    line-height: 0;
  }
</style>
